<template>
  <tr class="mainRow" :style="responsiveRow">
    <td :style="firstChild(i)" v-for="(data, i) in columnsData" :key="i">
      <span v-if="isRealtime(data)">
        <tooltip-realtime :data="data">
          <span class="a-realtime pa-1">{{ data.getValue() }}</span>
        </tooltip-realtime>
      </span>
      <span v-else-if="isConstant(data)">
        <tooltip-constant :data="data">
          <span class="a-constant pa-1">{{ data.value }}</span>
        </tooltip-constant>
      </span>
      <span v-else-if="isAlarm(data) || isAlarmsArray(data)">
        <div class="pl-1">
          <OnlineState :data="data" />
        </div>
      </span>
      <div v-else-if="data.value == 'alarm'" @click="$emit('openAlarm', item)">
        <AlarmBorder height="30px" showIcon clicked :item="item" />
      </div>
      <span class="darkMedium--text" v-else>
        {{ data }}
      </span>
    </td>
    <td>
        <v-btn icon small outlined color="primaryLight" :disabled="!isValidLink" :to="link">
          <v-icon size="16">arrow_forward</v-icon>
        </v-btn>
    </td>
  </tr>
</template>

<script>
import { typeChecking } from "@/components/mixins/typeChecking";
import OnlineState from "@/components/State/OnlineState.vue";
import AlarmBorder from "@/components/Alarms/AlarmBorder.vue";
import { mapGetters } from "vuex";
export default {
  name: "Row",
  components: {
    OnlineState,
    AlarmBorder,
  },
  mixins: [typeChecking],
  props: {
    columns: Array,
    item: Object,
  },
  data: () => ({
    columnsData: [],
    routePlant: "plants",
    link: "",
    loading: true,
  }),
  watch: {
    item: {
      immediate: true,
      handler(val) {
        this.loading = true;
        this.createListFromObject(val);
        this.setButtonLink(val);
        this.loading = false;
      },
    },
  },
  computed: {
    ...mapGetters(["showAlarms"]),
    isValidLink() {
      return !!this.link && typeof this.link === "string";
    },
    responsiveRow() {
      return {
        display: "grid",
        gridTemplateColumns: `${
          this.showAlarms ? "0.1fr" : "0.25fr"
        } 0.25fr repeat(${this.columnsData.length - 2}, 1fr) 0.25fr`,
      };
    },
  },
  methods: {
    async createListFromObject(item) {
      let headers = [...this.columns];
      let list = [];

      for (let index = 0; index < headers.length; index++) {
        const h = headers[index];
        let { value } = h;
        if (value == "alarm") {
          list.push({ value });
        } else if (Object.hasOwnProperty.call(item, value)) {
          list.push(item[value]);
        } else {
          list.push("-");
        }
      }

      this.columnsData = list;
    },
    setButtonLink(item) {
      const { id, sourceType } = item;
      this.link = `${this.routePlant}/${sourceType}/${id}`;
    },
    isAlarmsArray(data) {
      if (Array.isArray(data)) {
        return data.every((item) => this.isAlarm(item));
      }
      return false;
    },
    firstChild(index) {
      if (index == 0)
        return {
          "border-radius": "4px 0 0 4px !important",
          "justify-content": this.showAlarms ? "start" : "center",
          padding: "0px !important",
        };
      else if (index == 1 && this.showAlarms) {
        return {
          "border-radius": "4px 0 0 4px !important",
          "justify-content": "center",
          padding: "0px !important",
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mainRow {
  transition-delay: 20ms;
  transition-duration: 250ms;
  background: white !important;
  margin-bottom: 3px;
  padding: 3px 5px 3px 0px;
}
.mainRow:hover {
  box-shadow: inset 0px 0px 0px 1px #42ca73;
}
.v-btn {
  border-radius: 4px;
}
.alarm {
  cursor: pointer;
}
.alarm:hover {
  background: $light;
}
td {
  text-align: center;
  display: flex;
  padding: 4px 40%;
  height: 35px;
}
td:last-child {
  border-radius: 0px 4px 4px 0px !important;
  margin: 0px;
  padding: 0px !important;
  display: flex;
  justify-content: flex-end;
}
tr {
  display: flex;
  align-items: center !important;
  height: 35px;
}
</style>
